import { useLocation } from 'react-router-dom';

export type SectionType = 'tasks' | 'calendar' | 'persons' | 'contacts' | 'dashboard' | 'profile';

export interface SectionConfig {
  section: SectionType;
  primaryVariant: string;
  secondaryVariant: string;
  color: string;
}

export const useCurrentSection = (): SectionConfig => {
  const location = useLocation();
  const pathname = location.pathname;

  // Déterminer la section basée sur l'URL
  if (pathname.startsWith('/tasks') || pathname.includes('task-list')) {
    return {
      section: 'tasks',
      primaryVariant: 'tasks',
      secondaryVariant: 'tasks-secondary',
      color: 'hsl(var(--secondary))'
    };
  }

  if (pathname.startsWith('/calendar') || pathname.includes('event')) {
    return {
      section: 'calendar',
      primaryVariant: 'calendar',
      secondaryVariant: 'calendar-secondary',
      color: 'hsl(var(--accent))'
    };
  }

  if (pathname.startsWith('/persons') || pathname.includes('person')) {
    return {
      section: 'persons',
      primaryVariant: 'persons',
      secondaryVariant: 'persons-secondary',
      color: 'hsl(var(--coral))'
    };
  }

  if (pathname.startsWith('/contacts') || pathname.includes('contact')) {
    return {
      section: 'contacts',
      primaryVariant: 'persons',
      secondaryVariant: 'persons-secondary',
      color: 'hsl(var(--coral))'
    };
  }

  if (pathname.startsWith('/profile')) {
    return {
      section: 'profile',
      primaryVariant: 'default',
      secondaryVariant: 'outline',
      color: 'hsl(var(--neutral))'
    };
  }

  // Par défaut (dashboard)
  return {
    section: 'dashboard',
    primaryVariant: 'default',
    secondaryVariant: 'outline',
    color: 'hsl(var(--primary))'
  };
};